import { isSameYear } from 'date-fns/isSameYear';
import { isToday } from 'date-fns/isToday';

import { format } from '@eika-infrastruktur/date';

const defaultFormat = 'd. MMMM yyyy';

const getDateDisplayValue = (date?: Date, customFormat: string = defaultFormat): string => {
    if (!date) {
        return '';
    }
    const today = new Date();
    if (isToday(date)) return 'I dag';
    if (isSameYear(date, today)) {
        const monthFormat = customFormat
            .split(' ')
            .filter((x) => !x.toLowerCase().includes('y'))
            .join(' ');
        return format(date, monthFormat);
    }
    return format(date, customFormat);
};

export default getDateDisplayValue;
